module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG3feee67ca1d29bf3ab86f7bdd8e0ae80.3feee67c.png";